import Vue from 'vue'
import { store } from './store/store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import App from './App'
import router from './router'
import '../scss/custom.scss'

Vue.use(Vuetify, {
  theme: {
    primary: '#fff',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    mari: '#6928ff',
    'mari-darker': '#5c23e0',
    white: '#fff'
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js